import CardActivationScreen from 'features/cardManagement/screens/cardActivation/CardActivationScreen/CardActivationScreen';
import OnboardingEntryPointWrapper from 'features/onboarding/components/OnboardingEntryPointWrapper/OnboardingEntryPointWrapper';
import React from 'react';

export default function CardActivationPage() {
  return (
    <OnboardingEntryPointWrapper>
      <CardActivationScreen />
    </OnboardingEntryPointWrapper>
  );
}
